<template>
  <v-app v-if = existeSesion>
    <core-drawer @cerrarSesion = "existeSesion=false"></core-drawer>
    <core-view></core-view>
  </v-app>
  <v-app v-else>
      <core-login
        @inicioSesion = "activarDashboard"
      ></core-login>
      <core-footer></core-footer>
  </v-app>
</template>

<script>
export default {
  data: () => ({
     existeSesion: false
  }),
  created () {
      this.verificarSesion()
  },
  methods: {
    verificarSesion(){
      if(sessionStorage.getItem("20mmt16") != "" || sessionStorage.getItem("20mmt16") == "null" || sessionStorage.getItem("20mmt16") == null){
        this.existeSesion = false;
      }else{
        this.existeSesion = true;
      }
    },
    activarDashboard(){
      this.existeSesion = true;
    }
  }
}
</script>
<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>